import React from 'react';
import { Backlink } from '@ktag/styleguide/dist/react';
import useBacklinkUrl from './useBacklinkUrl';

interface Props {
  parentId?: string;
  parentFrontendId?: string;
  label: string;
}

const BackButton = ({ parentId, label, parentFrontendId }: Props) => {
  const url = useBacklinkUrl(parentId, parentFrontendId);

  return <Backlink text={label} url={`#${url}`} />;
};

export default BackButton;
